export class ValidationResult {
    ErrorMessage: string;
    MemberNames: string[];
}